import { DateHelper } from "@/Common/Helpers/DateHelper";
import { CodeValue } from "./CodeValue";
import { MedicationModel } from "./MedicationModel";
import { RvqMedicationPreference } from "./RvqMedicationPreference";

class MedicationBatchModel {
    public Id: number;
    public LotNumber: string;
    public ExpirationDate: Date;
    public DefaultRoute: CodeValue;
    public DefaultQuantity: number;
    public DefaultQuantityUnit: CodeValue;
    public IsExpired: boolean;
    public IsPublicProgram: boolean;

    public constructor(init?: Partial<MedicationBatchModel>) {
        Object.assign(this, init);
    }

    public static toRvqPreference(model: MedicationModel, batchModel: MedicationBatchModel): RvqMedicationPreference {
        return new RvqMedicationPreference({
            QuebecVaccinationRegistryId: model.TradeName,
            DisplayName: `${MedicationModel.getDisplayName(model)} - ${this.getDisplayName(batchModel)}`,
            Name: `${MedicationModel.getDisplayName(model)} - ${this.getDisplayName(batchModel)}`,
            LotNumber: batchModel.LotNumber,
            LotId: batchModel.Id,
            ItemId: sessionStore.newId()
        });
    }

    public static getDisplayName(batchModel: MedicationBatchModel): string {
        return `${batchModel.LotNumber} - Exp: ${DateHelper.formatIsoDateOnly(batchModel.ExpirationDate) || ""} - ${batchModel.DefaultQuantity} ${batchModel.DefaultQuantityUnit.Label}`;
    }

    public static getLotDisplayName(batchModel: MedicationBatchModel): string {
        if (!batchModel)
            return "";

        return batchModel.ExpirationDate
            ? `${batchModel.LotNumber} - Exp: ${DateHelper.formatIsoDateOnly(batchModel.ExpirationDate) || ""}`
            : batchModel.LotNumber;
    }
}

export { MedicationBatchModel };
